import { useScreenLayout } from '@/hooks/screen'
import { FC, ReactNode } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface PaperWrapperProps {
    children: ReactNode
}

const PaperWrapper: FC<PaperWrapperProps> = ({ children }) => {
    const screenLayout = useScreenLayout()

    const { styles } = useStyles(stylesheet, { layout: screenLayout })

    if (!children) {
        return null
    }

    return <View style={styles.wrapper}>{children}</View>
}

const stylesheet = createStyleSheet((_, { insets }) => ({
    wrapper: {
        position: 'absolute',
        variants: {
            layout: {
                extended: {
                    width: 375,
                    top: insets.top + 53,
                    bottom: 9,
                    right: 4,
                },
                compact: {
                    width: '100%',
                    top: insets.top + 52,
                    bottom: 0,
                },
            },
        },
    },
}))

export default PaperWrapper
